import { t } from 'i18next';
import { Lock } from 'lucide-react';
import { Trans } from 'react-i18next';

import { UpgradeButton } from '@/features/usage/components/upgrade-button';

type LockedPieceBannerProps = {
  pieceDisplayName: string;
};

export const LockedPieceBanner = ({
  pieceDisplayName,
}: LockedPieceBannerProps) => {
  return (
    <div className="m-2 p-2 rounded-lg border bg-muted/40 flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <div className="bg-[#55c96b]/10 text-[#55c96b] p-2 rounded-sm">
          <Lock className="h-4 w-4 shrink-0" />
        </div>
        <div>
          <span className="text-sm">
            <Trans
              i18nKey="Unlock <strong>{{piece}}</strong>"
              values={{ piece: pieceDisplayName }}
              components={{ strong: <strong /> }}
            />
          </span>
          <p className="text-xs text-muted-foreground">
            {t('Included in the Business plan')}
          </p>
        </div>
      </div>
      <UpgradeButton size="sm" />
    </div>
  );
};
